export const SD = {
    translations: {
        notifications: 'نوٽيفڪيشن',
        markAllAsRead: 'سڀني کي پڙهيل طور نشان لڳايو',
        poweredBy: 'پاران تيار ڪيل',
        settings: 'سيٽنگون',
        noNewNotification: 'هتي ڏسڻ لاءِ اڃا ڪجهه نئون ناهي',
    },
    lang: 'sd',
};
//# sourceMappingURL=sd.js.map